/**
 * @file
 * A JavaScript file for the site.
 *
 */

(function ($) {
  var sliderNav = $(".hero--slider--nav");
  var slider = $(".slideshow");

  // Fix Slick's ARIA roles for accessibility.
  function fixSlickDotsAria($container) {
    var $dots = $container.find(".slick-dots");
    if ($dots.length) {
      $dots.removeAttr("role");
      $dots.find("li").removeAttr("role");
    }
  }

  // slick slideshow
  if (slider.length && slider.children().length > 0) {
    var $uninitializedSlider = slider.not(".slick-initialized");
    if ($uninitializedSlider.length) {
      $uninitializedSlider.slick({
        appendDots: sliderNav,
        appendArrows: sliderNav,
        slidesToShow: 1,
        slidesToScroll: 1,
        fade: true,
        dots: true,
        arrows: true,
        prevArrow:
          "<button type='button' class='slick-prev slick-arrow' aria-label='Previous slide'><img src='/themes/custom/umsi/assets/images/svgs/right-arrow-maize.svg' alt='' aria-hidden='true'></button>",
        nextArrow:
          "<button type='button' class='slick-next slick-arrow' aria-label='Next slide'><img src='/themes/custom/umsi/assets/images/svgs/right-arrow-maize.svg' alt='' aria-hidden='true'></button>",
      });
      // Fix ARIA roles after slick creates the dots
      fixSlickDotsAria(sliderNav);
    }

    $(".hero--slider--nav .slick-prev").on("click", function () {
      slider.slick("slickPrev");
    });
    $(".hero--slider--nav .slick-next").on("click", function () {
      slider.slick("slickNext");
    });
  }

  // image gallery
  var imgGallery = $(".slider--display").not(".media-mentions");
  if (imgGallery.length && imgGallery.children().length > 0) {
    var $uninitializedGallery = imgGallery.not(".slick-initialized");
    if ($uninitializedGallery.length) {
      $uninitializedGallery.slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: true,
        dots: true,
        prevArrow:
          "<button type='button' class='slick-prev slick-arrow' aria-label='Previous slide'><img src='/themes/custom/umsi/assets/images/svgs/right-arrow.svg' alt='' aria-hidden='true'></button>",
        nextArrow:
          "<button type='button' class='slick-next slick-arrow' aria-label='Next slide'><img src='/themes/custom/umsi/assets/images/svgs/right-arrow.svg' alt='' aria-hidden='true'></button>",
        fade: true,
        centerMode: true,
      });
      // Fix ARIA roles after slick creates the dots
      $uninitializedGallery.each(function () {
        fixSlickDotsAria($(this));
      });
    }

    // lightbox
    imgGallery.slickLightbox({
      src: "src",
      itemSelector: ".slick-list img",
      navigateByKeyboard: true,
      caption: function (element, info) {
        return $(element)
          .parents(".slider--image")
          .find(".slider--caption")
          .html();
      },
    });
  }

  // media mentions carousel
  var mediaMentions = $(".media-mentions.slider--display");
  if (mediaMentions.length && mediaMentions.children().length > 0) {
    mediaMentions.not(".slick-initialized").slick({
      infinite: true,
      arrows: true,
      dots: false,
      prevArrow:
        "<button type='button' class='slick-prev slick-arrow' aria-label='Previous slide'><img src='/themes/custom/umsi/assets/images/svgs/right-arrow.svg' alt='' aria-hidden='true'></button>",
      nextArrow:
        "<button type='button' class='slick-next slick-arrow' aria-label='Next slide'><img src='/themes/custom/umsi/assets/images/svgs/right-arrow.svg' alt='' aria-hidden='true'></button>",
      slidesToShow: 3,
      slidesToScroll: 1,
      responsive: [
        {
          breakpoint: 1024,
          settings: {
            slidesToShow: 3,
          },
        },
        {
          breakpoint: 600,
          settings: {
            slidesToShow: 2,
          },
        },
        {
          breakpoint: 480,
          settings: {
            slidesToShow: 1,
          },
        },
      ],
    });
  }

  // carousel component image gallery
  $(".carousel-component.dark .carousel.slider--display").each(function () {
    var $this = $(this);
    var $children = $this.children(".slider--image");
    if ($children.length > 0 && !$this.hasClass("slick-initialized")) {
      $this.slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        infinite: true,
        arrows: true,
        dots: true,
        prevArrow:
          "<button type='button' class='slick-prev slick-arrow' aria-label='Previous slide'><img src='/themes/custom/umsi/assets/images/svgs/right-arrow-white.svg' alt='' aria-hidden='true'></button>",
        nextArrow:
          "<button type='button' class='slick-next slick-arrow' aria-label='Next slide'><img src='/themes/custom/umsi/assets/images/svgs/right-arrow-white.svg' alt='' aria-hidden='true'></button>",
        fade: true,
        centerMode: true,
      });
      fixSlickDotsAria($this);
    }
  });

  $(".carousel-component:not(.dark) .carousel.slider--display").each(
    function () {
      var $this = $(this);
      var $children = $this.children(".slider--image");
      if ($children.length > 0 && !$this.hasClass("slick-initialized")) {
        $this.slick({
          slidesToShow: 1,
          slidesToScroll: 1,
          infinite: true,
          arrows: true,
          dots: true,
          prevArrow:
            "<button type='button' class='slick-prev slick-arrow' aria-label='Previous slide'><img src='/themes/custom/umsi/assets/images/svgs/right-arrow.svg' alt='' aria-hidden='true'></button>",
          nextArrow:
            "<button type='button' class='slick-next slick-arrow' aria-label='Next slide'><img src='/themes/custom/umsi/assets/images/svgs/right-arrow.svg' alt='' aria-hidden='true'></button>",
          fade: true,
          centerMode: true,
        });
        fixSlickDotsAria($this);
      }
    }
  );
})(jQuery);
